import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/editorui/editoruiview
 */
import View from '../view';
import BodyCollection from './bodycollection';
import '../../theme/components/editorui/editorui.css';
/**
 * The editor UI view class. Base class for the editor main views.
 *
 * @extends module:ui/view~View
 */

var EditorUIView = /*#__PURE__*/function (_View) {
  _inherits(EditorUIView, _View);

  var _super = _createSuper(EditorUIView);

  /**
   * Creates an instance of the editor UI view class.
   *
   * @param {module:utils/locale~Locale} [locale] The locale instance.
   */
  function EditorUIView(locale) {
    var _this;

    _classCallCheck(this, EditorUIView);

    _this = _super.call(this, locale);
    /**
     * Collection of the child views, detached from the DOM
     * structure of the editor, like panels, icons etc.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection} #body
     */

    _this.body = new BodyCollection(locale);
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EditorUIView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(EditorUIView.prototype), "render", this).call(this);

      this.body.attachToDom();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.body.detachFromDom();
      return _get(_getPrototypeOf(EditorUIView.prototype), "destroy", this).call(this);
    }
  }]);

  return EditorUIView;
}(View);

export { EditorUIView as default };